import type { FC } from 'react';

import type { IconProps } from './types';

const Unsplash: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M356.849.001c-25.706 0-46.545 20.839-46.545 46.545v186.182c0 25.706 20.839 46.545 46.545 46.545h310.303c25.706 0 46.545-20.839 46.545-46.545V46.546c0-25.706-20.839-46.545-46.545-46.545zM46.546 403.394c-25.706 0-46.545 20.839-46.545 46.545v527.516c0 25.706 20.839 46.545 46.545 46.545h930.909c25.706 0 46.545-20.839 46.545-46.545V449.939c0-25.706-20.839-46.545-46.545-46.545H760.243c-25.706 0-46.545 20.839-46.545 46.545v263.757H310.305V449.939c0-25.706-20.839-46.545-46.545-46.545H46.548z"
      fill={color}
    />
  </svg>
);

export default Unsplash;
